import { AspectRatio, AspectRatioProps, Image } from "@chakra-ui/react";
import { traitsFilesUrl } from "config";
import { ImageSize } from "types";

export type TraitImageProps = Omit<AspectRatioProps, "ratio" | "color"> & {
  tokenId: number;
  postfix?: string;
  size?: ImageSize;
  isDisabled?: boolean;
};

const TraitImage = ({
  tokenId,
  postfix,
  size = "512",
  isDisabled = false,
  ...rest
}: TraitImageProps) => {
  let src = `${traitsFilesUrl}/${tokenId}${size === "full" ? "" : `_${size}`}${
    postfix ? "_" + postfix : ""
  }.png`;

  return tokenId !== 0 ? (
    <AspectRatio ratio={1} w="full" borderRadius="md" {...rest}>
      <Image
        src={src}
        fit="cover"
        transition="opacity 0.15s"
        alt={`${tokenId}`}
      />
    </AspectRatio>
  ) : null;
};

export default TraitImage;
